import { JWTPayload } from 'jose'

export enum UserRole {
  UR_ACCESS = 'ur_access',
}

export interface KeycloakJwtPayload extends JWTPayload {
  realm_access?: {
    roles: string[]
  }
}
